import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_FREE_OF_CHARGE_RULE,
  CLEAR_FREE_OF_CHARGE_RULES,
  FLAG_FREE_OF_CHARGE_RULE_ACTIVITY,
  FLAG_GETTING_FREE_OF_CHARGE_RULES,
  GET_FREE_OF_CHARGE_RULE,
  GET_FREE_OF_CHARGE_RULES,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_FREE_OF_CHARGE_RULES:
      return state.setIn(['all', 'loading'], payload);
    case GET_FREE_OF_CHARGE_RULES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_FREE_OF_CHARGE_RULES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case GET_FREE_OF_CHARGE_RULE:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_FREE_OF_CHARGE_RULE:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    case FLAG_FREE_OF_CHARGE_RULE_ACTIVITY:
      // raising flag
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      // lowering flag
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    default:
      return state;
  }
};
